import { SyntheticEvent } from 'react';
import { FactorBriefCase } from '@/features/factor-briefcase';
import { FactorDeals } from '@/features/factor-deals';
import { FactorMoneyFlow } from '@/features/factor-money-flow';
import { CabinetWrapper } from '@/shared/cabinet-wrapper';
import UITabs from '@/shared/ui/ui-tabs';
import { useSearchParams } from 'react-router-dom';
import { useGetClientsListQuery, useGetOKEDListQuery } from '../../app/api';

import { useTranslation } from 'react-i18next';

export const FactorMainPage = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = Number(searchParams.get('activeTab')) || 0;

  const { data: clientsList } = useGetClientsListQuery({});
  const { data: okedList } = useGetOKEDListQuery({});

  const handleTabChange = (
    _event: SyntheticEvent<Element, Event>,
    newValue: number
  ) => {
    const params = new URLSearchParams(window.location.search);
    params.set('activeTab', String(newValue));
    setSearchParams(params);
  };

  return (
    <CabinetWrapper>
      <UITabs
        value={activeTab}
        onChange={handleTabChange}
        tabs={[
          {
            label: t('briefcase'),
            component: (
              <FactorBriefCase
                clientsList={clientsList?.data}
                okedList={okedList?.data}
              />
            ),
          },
          {
            label: t('deals'),
            component: <FactorDeals clientsList={clientsList?.data} />,
          },
          {
            label: t('money_flow'),
            component: <FactorMoneyFlow clientsList={clientsList?.data} />,
          },
        ]}
      />
    </CabinetWrapper>
  );
};
